import { API } from "../../../../utility/API"
// import {_setAPIToken} from '../../../../utility/Utils'
// import _ from "lodash"
// import { persistStore } from 'redux-persist'
//************************************//
export const _getCurrencies = (callback, callbackErr) => {
  API.get(`trading/public/currencies`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (error) {
      callbackErr(error.response.data)
    })
}
//************************************//
export const _previewConversion = (data, callback, callbackErr) => {
  API.post(`trading/market/conversions/preview`, data)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (error) {
      callbackErr(error.response?.data)
    })
}
//************************************//
export const _convert = (id, callback, callbackErr) => {
  API.post(`trading/market/conversions/${id}/confirm `)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (error) {
      callbackErr(error.response.data)
    })
}
//************************************//
export const _getCoinKline = (data, callback, callbackErr) => {
  let url = `trading/public/markets/k-line?period=1440`
  if (data && data.pairs && data.pairs.length > 0) {
    url += data.pairs.map((pair) => `&markets[]=${pair}`).join("")
  }
  API.get(url, { params: data })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
      callbackErr(data)
    })
}
//************************************//
export const _getAvailableCurrencies = (currency, callback, callbackErr) => {
  API.get(`/trading/public/available_currencies`, {
    params: { currency }
  })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (error) {
      callbackErr(error.response?.data)
    })
}
//************************************//
export const _getMaximumConvertAmount = (currency, callback, callbackErr) => {
  console.log(`API CALL: Getting maximum convert amount for currency: ${currency}`)

  // Validate currency parameter
  if (!currency) {
    console.error('Missing required parameter: currency')
    callbackErr({ errors: ['Missing required parameter: currency'] })
    return
  }

  API.post(`/trading/market/conversions/maximum_amount`, null, {
    params: { currency }
  })
    .then(function ({ data }) {
      console.log(`Maximum convert amount API success for ${currency}:`, data)
      callback(data)
    })
    .catch(function (error) {
      console.error(`Maximum convert amount API error for ${currency}:`, error)
      callbackErr(error.response?.data || error)
    })
}
//************************************//
